import React from "react";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import Marquee from "react-fast-marquee";
import { Grid } from "@mantine/core";
import { Link } from "react-router-dom";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./AboutPiLog.css";
import Image1 from "../../Components/Assets/AboutPiLog/Dr.-Salomon-De-Jager_Pic.png";
import Image2 from "../../Components/Assets/AboutPiLog/Pieter-Strydom_Pic.png";
import Image3 from "../../Components/Assets/AboutPiLog/Gideon-Huisamen_Pic.png";
import Image4 from "../../Components/Assets/AboutPiLog/Dr.-Imad-Syed_Pic.png";
import Image5 from "../../Components/Assets/AboutPiLog/Wynand-Nortje_Pic.png";
import Image6 from "../../Components/Assets/AboutPiLog/Tracy-Bennett_Pic.png";
import Image7 from "../../Components/Assets/AboutPiLog/Reinhard-Schiel_Pic.png";
import Image8 from "../../Components/Assets/AboutPiLog/Johan-Zwarts_Pic.png";
import { ClientLogosSection } from "../../Components/ui/clientLogo/ClientLogo";
import { clientLogosAboutUs } from "./contant";

const offices = [
  {
    region: "India",
    address:
      "3rd Floor, Unit-1, MJR Magnifique, Raidurg Navakhalsa, Hyderabad, Telangana - 500 008",
    email: "info@piloggroup.com",
    phone: "+91 630 176 0928",
  },
  {
    region: "Saudi Arabia",
    address:
      "Office 2-2, Palm Commercial Centre, Fanateer, Jubail, Kingdom of Saudi Arabia",
    email: "info@piloggroup.com",
    phone: "+966 13 347 2595",
  },
  {
    region: "UAE",
    address:
      "4th Floor, office No.406, Abudhabi Plaza Tower, Fatima Bint. Mubarak Street,Abu Dhabi",
    email: "info@piloggroup.com",
    phone: "+971 2 555 6722",
  },
  {
    region: "Americas",
    address: "401 College St Suite 208 Montgomery, TX 77356",
    email: "info@piloggroup.com",
    phone: "+1 888 291 7242",
  },
  {
    region: "South Africa",
    address:
      "Building 5, Centurion Gate, Akkerboom St, Zwartkop, Centurion, South Africa - 0157",
    email: "info@piloggroup.com",
    phone: "+27 12 663 2210",
  },

  {
    region: "Europe and CIS",
    address: "6B Mykilsko Slobidska St, Kyiv Ukraine. 02002",
    email: "info@piloggroup.com",
    phone: "+380 96 309 5232",
  },

  {
    region: "Belgium",
    address:
      "Building 5, Centurion Gate, Akkerboom St, Zwartkop, Centurion, South Africa - 0157",
    email: "info@piloggroup.com",
    phone: "+27 12 663 2210",
  },
];

export const AboutUs = () => {
  const slides = [
    {
      id: 1,
      title: "Dr. Salomon De Jager",
      position: "Chairman",
      description:
        "In 1995 Dr Salomon founded Pilog to become a leader in content creation and data governance. He participated in ISO TC184/SC4 since 2006 and initiated a South African mirror committee, SABS TC184 within the South African Bureau of Standards. ",
      linkText: "Read Case Study →",
      leader: Image1,
    },
    {
      id: 2,
      title: "Pieter Strydom",
      position: "Co - Chief Executive Officer",
      description:
        "Mr Strydom has a Mechanical Engineering degree from the University of Pretoria, South Africa, and furthered his studies with a MBL from Unisa. He started his career at Eskom as Maintenance Engineer in the nuclear field. ",
      linkText: "Read Case Study →",
      leader: Image2,
    },
    {
      id: 3,
      title: "Gideon Huisamen",
      position: "Co - Chief Executive Officer",
      description:
        "He worked as a Management and Cost accountant for 16 years in South Africa with a Telecom Company and also later in a food Canning Manufacturing Company.  ",
      linkText: "Read Case Study →",
      leader: Image3,
    },
    {
      id: 4,
      title: "Dr. Imad Syed",
      position: "Co - Chief Executive Officer & Chief Information Officer",
      description:
        "Senior Executive, Digital Advisory, Visionary Leader with vast experience in conceiving & designing business, enterprise information and data quality HUB strategies for medium to large enterprises ",
      linkText: "Read Case Study →",
      leader: Image4,
    },
    {
      id: 5,
      title: "Wynand Nortje",
      position: "Chief Technology Officer",
      description:
        "Mr Wynand Nortje obtained his Industrial Engineering degree from the University of Pretoria, South Africa and furthered his studies with a B.Sc Honours degree in Operations Research. ",
      linkText: "Read Case Study →",
      leader: Image5,
    },
    {
      id: 6,
      title: "Tracy Bennett",
      position: "Chief Operating Officer",
      description:
        "He was a former GEO-market CFO for operations and shared 500 services. Director for a Fortune 500 company and Global perspective with 17 years of international experience. ",
      linkText: "Read Case Study →",
      leader: Image6,
    },
    {
      id: 7,
      title: "Reinhard Schiel",
      position: "Chief Operating Officer",
      description:
        "He started his career as a telecommunications engineer in the laboratories of Telkom after completing his Electrotechnical Engineering degree at the University of Pretoria.  ",
      linkText: "Read Case Study →",
      leader: Image7,
    },
    {
      id: 8,
      title: "Johan Zwarts",
      position: "Chief Operating Officer",
      description:
        "Johan is the Chief Operating Officer and Senior Program Manager at PiLog Africa for various PiLog Clients involved in the world of Master Data Quality Management and related solutions.",
      linkText: "Read Case Study →",
      leader: Image8,
    },
  ];
  return (
    <div>
      <section className="about-pilog">
        <Container>
          <Row>
            <Col lg={7} className="about-ilog-left">
              {/* <h1>About PiLog</h1> */}
              <p>
                PiLog Group delivers cutting-edge, end-to-end enterprise data
                lifecycle management, empowering organizations across industries
                worldwide with multi-domain data solutions. Built on lean
                management principles, its data quality and governance suite
                integrates industry best practices, ISO standards, and AI-driven
                content via intelligent AI Agents. Offering robust features for
                Enterprise Data Management, Supply Chain, Data Migration, Data
                Quality, and Governance, PiLog ensures seamless integration with
                SAP S4 On-Premise and SAP BTP Cloud. Recognized by Gartner and
                Software Reviews, PiLog stands as a trusted leader in
                transforming data into a strategic asset.
              </p>
            </Col>
            <Col lg={5}>
              <img
                loading="lazy"
                src={require("../../Components/Assets/AboutPiLog/About-PiLog_Image.png")}
                alt=""
                height={"300px"}
                width={"100%"}
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* <section className="pilog-fact-sheet">
        <Container className="fact-sheet-sec">
          <h2>Fact Sheet</h2>
          <p style={{ fontSize: "1.1rem" }}>
            A Snapshot of Excellence, Innovation, and Impact.
          </p>
          <Row>
            <Col lg={4}>
              <div className="pilog-fact-sheets">
                <h5>Awards</h5>
              </div>
            </Col>
            <Col lg={4}>
              <div className="pilog-fact-sheets">
                <h5>Partners</h5>
              </div>
            </Col>
            <Col lg={4}>
              <div className="pilog-fact-sheets">
                <h5>iContent Foundry</h5>
              </div>
            </Col>
            <Col lg={4}>
              <div className="pilog-fact-sheets">
                <h5>History</h5>
              </div>
            </Col>
            <Col lg={4}>
              <div className="pilog-fact-sheets">
                <h5>Customers</h5>
              </div>
            </Col>
            <Col lg={4}>
              <div className="pilog-fact-sheets">
                <h5>Add-Ons</h5>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}

      <section className="leading-companies">
        <ClientLogosSection
          logos={clientLogosAboutUs}
          columns={{ base: 12, xs: 4, md: 3, lg: 2 }}
        />
      </section>
      <section className="my-3 py-3 ">
        <Container>
          <div>
            <h2 className="text-center" style={{ fontSize: "2.5rem" }}>
              Our Partners
            </h2>
            <p className="text-center" style={{ fontSize: "1.1rem" }}>
              Collaborating for excellence, amplifying impact, and driving
              success through trusted partnerships.
            </p>
          </div>
          <Row className="my-3 justify-content-center">
            <Col lg={6} className="p-3">
              <div className="partner-cards">
                <img
                  loading="lazy"
                  width={"20%"}
                  src="https://piloggroup.com/img/partners/SAP_Silver_Partner_Logo.png"
                  alt=""
                />
                <h5>SAP </h5>
                <p style={{ fontSize: "15px", height: "100px", color: "#555" }}>
                  PiLog is Co-Innovated with SAP, implementing the SAP master
                  data governance application.
                </p>
                <button className="partner-btn">Learn More</button>
              </div>
            </Col>
            {/* <Col lg={6} className="p-3">
              <div className="partner-cards">
                <img
                  loading="lazy"
                  style={{ width: "20%" }}
                  src="https://piloggroup.com/img/partners/ORACLE_Partnernetwork_%20Logo.png"
                  alt=""
                />
                <h5>Oracle - Partner Network</h5>
                <p style={{ fontSize: "15px", height: "100px", color: "#555" }}>
                  Oracle is one of the world leaders on integrated data
                  solutions for Customer Party data which is generally being
                  referred to as structured data.
                </p>
                <button className="partner-btn">Learn More</button>
              </div>
            </Col> */}
            {/* <Col lg={6} className="p-3">
              <div className="partner-cards">
                <img
                  loading="lazy"
                  src="https://piloggroup.com/img/partners/PARTNERS-LOGOS-03.png"
                  alt=""
                  width={"22%"}
                />
                <h5>Siveco Group- COSWIN</h5>
                <p style={{ fontSize: "15px", height: "100px", color: "#555" }}>
                  From 1993 PiLog has been a partner with Siveco Group, a major
                  international player and the European leader in the CMMS
                  market since 1986.
                </p>
                <button className="partner-btn">Learn More</button>
              </div>
            </Col> */}
            {/* new partners */}
            {/* <Col lg={6} className="p-3">
              <div className="partner-cards">
                <img
                  loading="lazy"
                  src={require("../../Components/Assets/AboutPiLog/partners/itego-logo.png")}
                  alt=""
                  width={"22%"}
                />
                <h5>Itego</h5>
                <p style={{ fontSize: "15px", height: "100px", color: "#555" }}>
                  Itego offer SAP based Itego Reference Data Management (RDM) –
                  Add-On for SAP MDG
                </p>
                <button className="partner-btn">Learn More</button>
              </div>
            </Col>
            <Col lg={6} className="p-3">
              <div className="partner-cards">
                <img
                  loading="lazy"
                  style={{ width: "22%" }}
                  src="https://piloggroup.com/img/partners/PARTNERS-LOGOS-03.png"
                  alt=""
                  width={"22%"}
                />
                <h5>Asint</h5>
                <p style={{ fontSize: "15px", height: "100px", color: "#555" }}>
                  Asint applications streamline and enhance your inspection
                  processes, providing a reliable and user-friendly platform for
                  managing all aspects of mechanical integrity.
                </p>
                <button className="partner-btn">Learn More</button>
              </div>
            </Col>
            <Col lg={6} className="p-3">
              <div className="partner-cards">
                <svg
                  viewBox="0 0 874 189"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ width: "200px" }}
                  width="200px"
                >
                  <path
                    d="M405.154 62.5779C422.324 62.5779 436.442 48.5873 436.442 31.2899C436.442 14.1196 422.451 0.00176811 405.154 0.00176811C387.856 0.00176811 373.866 13.9924 373.866 31.2899C373.866 48.4602 387.856 62.5779 405.154 62.5779Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M474.911 1.08115H454.042V61.4986H474.911V1.08115Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M523.799 62.5797C540.969 62.5797 555.087 48.5883 555.087 31.2899C555.087 14.1186 541.096 0 523.799 0C506.501 0 492.511 13.9914 492.511 31.2899C492.638 48.4611 506.501 62.5797 523.799 62.5797Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M603.975 62.5797C621.145 62.5797 635.263 48.5883 635.263 31.2899C635.263 14.1186 621.272 0 603.975 0C586.805 0 572.687 13.9914 572.687 31.2899C572.814 48.4611 586.805 62.5797 603.975 62.5797Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M684.151 62.5797C701.321 62.5797 715.439 48.5883 715.439 31.2899C715.439 14.1186 701.449 0 684.151 0C666.854 0 652.863 13.9914 652.863 31.2899C652.99 48.4611 666.981 62.5797 684.151 62.5797Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M764.327 62.5797C781.498 62.5797 795.615 48.5883 795.615 31.2899C795.615 14.1186 781.625 0 764.327 0C747.157 0 733.039 13.9914 733.039 31.2899C733.039 48.4611 747.03 62.5797 764.327 62.5797Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M834.084 1.08115H813.215V61.4986H834.084V1.08115Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M872.553 1.08115H851.684V61.4986H872.553V1.08115Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M414.743 168.87V94.23H396.456V186.514H455.381V168.87H414.743Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M508.442 92.5796C481.659 92.5796 460.842 113.524 460.842 140.181C460.842 166.965 481.786 187.783 508.442 187.783C534.717 187.783 556.042 166.458 556.042 140.181C556.042 114.032 534.717 92.5796 508.442 92.5796ZM537.51 140.308C537.51 157.064 524.816 170.266 508.442 170.266C492.067 170.266 479.247 157.191 479.247 140.308C479.247 123.552 492.067 110.351 508.442 110.351C524.816 110.478 537.51 123.552 537.51 140.308Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M48.6224 110.478C59.5438 110.478 68.6873 115.682 74.402 125.203L75.2909 126.726L91.0381 117.586L90.1491 116.063C81.6406 101.338 66.1474 92.7065 48.6224 92.7065C21.8269 92.7065 1 113.651 1 140.308C1 167.092 21.9539 187.91 48.6224 187.91C66.1474 187.91 81.6406 179.151 90.1491 164.553L91.0381 163.03L75.2909 153.891L74.402 155.414C68.6873 164.934 59.4168 170.139 48.6224 170.139C32.2403 170.139 19.414 157.064 19.414 140.181C19.287 123.552 32.1133 110.478 48.6224 110.478Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M160.504 150.21C160.504 162.65 153.519 170.266 141.836 170.266C130.026 170.266 123.041 162.777 123.041 150.21V94.23H104.754V149.956C104.754 172.678 119.739 188.037 141.963 188.037C164.06 188.037 179.045 172.678 179.045 149.956V94.23H160.758V150.21H160.504Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M361.152 150.21C361.152 162.65 354.168 170.266 342.484 170.266C330.674 170.266 323.689 162.777 323.689 150.21V94.23H305.402V149.956C305.402 172.678 320.388 188.037 342.611 188.037C364.708 188.037 379.693 172.678 379.693 149.956V94.23H361.406V150.21H361.152Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M616.789 110.478C627.711 110.478 636.854 115.682 642.569 125.203L643.458 126.726L659.205 117.586L658.316 116.063C649.808 101.338 634.314 92.7065 616.789 92.7065C589.994 92.7065 569.167 113.651 569.167 140.308C569.167 167.092 590.121 187.91 616.789 187.91C634.314 187.91 649.808 179.151 658.316 164.553L659.205 163.03L643.458 153.891L642.569 155.414C636.854 164.934 627.584 170.139 616.789 170.139C600.407 170.139 587.581 157.064 587.581 140.181C587.454 123.552 600.407 110.478 616.789 110.478Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M693.24 94.23H674.953V186.514H693.24V94.23Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M709.113 111.874H734.893V186.514H753.18V111.874H778.959V94.23H709.113V111.874Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M850.964 94.23L828.106 129.265L805.501 94.23H783.912L818.962 147.798V186.514H837.376V147.925L872.553 94.23H850.964Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M241.906 141.959L212.063 94.23H195.808V186.514H214.095V130.28L236.064 165.315H248.002L269.845 130.407V186.514H288.132V94.23H271.876L241.906 141.959Z"
                    fill="currentColor"
                  ></path>
                </svg>
                <h5>Cumulocity</h5>
                <p style={{ fontSize: "15px", height: "100px", color: "#555" }}>
                  Cumulocity helps you to collect, manage and analyze your
                  machine data to transform it into valuable insights,
                  operational efficiency gains and digital services using
                  Digital Twin Technology
                </p>
                <button className="partner-btn">Learn More</button>
              </div>
            </Col> */}
          </Row>
        </Container>
      </section>
      <section className="p-5" style={{ background: "#fff" }}>
        <Container>
          <div>
            <h2 className="text-center" style={{ fontSize: "2.5rem" }}>
              Partner Program
            </h2>
            <p className="text-center" style={{ fontSize: "1.1rem" }}>
              Let's collaborate, co-sell, and grow together with synergized
              partnerships
            </p>
          </div>
          <Row className="align-items-center mt-5">
            <Tabs
              defaultActiveKey="Sales Representative"
              id="fill-tab-example"
              className="mb-4 border"
              fill
            >
              <Tab eventKey="Sales Representative" title="Sales Representative">
                <div>
                  <Row>
                    <div className="partner-programs-heading">
                      <div className="empty-div"></div>
                      <h2 className="text-dark">Sales Representative</h2>
                    </div>
                    <Col lg={7}>
                      <div className="partner-programs-content">
                        <p className="d-flex text-align-left">
                          Sales Representative could be an Individual or a
                          Company/Organization. Anyone interested in the Sales
                          and Marketing of PiLog Products, Services, or
                          Solutions can benefit. As part of this program, the
                          Sales Representative will generate the leads to sell
                          our Solutions. He will be backed up by Pre-sales Team,
                          who will provide technical support and give demos to
                          New Customers when leads are generated.
                        </p>
                        <p>✦ Assessment & Approval</p>
                        <p>✦ Formal Agreement</p>
                        <p>✦ Basic Sales Kit</p>
                        <p>✦ CRM Access</p>
                        <p>✦ Sales Enablement</p>
                        <p>✦ Referral incentive</p>
                        <p>✦ Perks for Excellence</p>
                      </div>
                    </Col>
                    <Col lg={5}>
                      <img
                        loading="lazy"
                        className="w-100"
                        src={require("../../Components/Assets/AboutPiLog/Co-Sell Partner.png")}
                        alt="Spares Data Acquisition-1"
                        width={"100%"}
                      />
                    </Col>
                  </Row>
                </div>
              </Tab>
              <Tab eventKey="Co-Sell Partner" title="Co-Sell Partner">
                <div>
                  <Row>
                    <Col lg={7}>
                      <div className="partner-programs-heading">
                        <div className="empty-div"></div>
                        <h2 className="text-start">Co-Sell Partner</h2>
                      </div>
                      <div className="partner-programs-content">
                        <p className="d-flex text-align-left">
                          Co-sell partner can be either individual or companies
                          likely to extend their growth in PiLog. Become a
                          co-sell partner of PiLog with a qualified team
                          expertise in networking and market knowledge having
                          viability, values and ethics along with committed
                          tenure and non-competition.
                        </p>
                        <p>✦ Assessment & Approval</p>
                        <p>✦ Formal Agreement</p>
                        <p>✦ Advanced Sales Kit</p>
                        <p>✦ CRM Access</p>
                        <p>✦ Sales Enablement</p>
                        <p>✦ Accreditation</p>
                        <p>✦ Partner Advisor</p>
                        <p>✦ Revenue Share</p>
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <img
                          loading="lazy"
                          style={{ width: "100%" }}
                          src={require("../../Components/Assets/AboutPiLog/Co-Sell Partner.png")}
                          alt="Spares Data Acquisition-7"
                          width={"100%"}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Tab>
              <Tab eventKey="Co-Service Partner" title="Co-Service Partner">
                <div>
                  <Row>
                    <Col lg={7}>
                      <div className="partner-programs-heading">
                        <div className="empty-div"></div>
                        <h2 className="text-start">Co-Service Partner</h2>
                      </div>
                      <div className="partner-programs-content">
                        <p className="d-flex text-align-left">
                          In this partnership either the individual or companies
                          can sell our products and also support us in
                          implementation at the customer premises. Be a
                          co-service partner of PiLog with a qualified team
                          expertise in networking and market knowledge having
                          viability, values and ethics along with committed
                          tenure and non-competition.
                        </p>
                        <p>✦ Assessment & Approval</p>
                        <p>✦ Formal Agreement</p>
                        <p>✦ Advanced Sales Kit</p>
                        <p>✦ CRM Access</p>
                        <p>✦ Sales Enablement</p>
                        <p>✦ Accreditation</p>
                        <p>✦ Partner Advisor</p>
                        <p>✦ Revenue Share</p>
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <img
                          loading="lazy"
                          style={{ width: "100%" }}
                          src={require("../../Components/Assets/AboutPiLog/Co-Sell Partner.png")}
                          alt="Spares Data Acquisition-7"
                          width={"100%"}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Tab>
              <Tab
                eventKey="VAR or Strategic Partner"
                title="VAR or Strategic Partner"
              >
                <div>
                  <Row>
                    <Col lg={7}>
                      <div className="partner-programs-heading">
                        <div className="empty-div"></div>
                        <h2 className="text-start">VAR or Strategic Partner</h2>
                      </div>
                      <div className="partner-programs-content">
                        <p className="d-flex text-align-left">
                          VAR partner program is for companies who can sell our
                          products and also support us in implementation at the
                          customer premises. Be a VAR partner of PiLog with a
                          qualified team expertise in networking and market
                          knowledge having viability, values and ethics along
                          with committed numbers and non-competition.
                        </p>
                        <p>✦ Assessment & Approval</p>
                        <p>✦ Formal Agreement</p>
                        <p>✦ Basic Sales Kit</p>
                        <p>✦ CRM Access</p>
                        <p>✦ Sales Enablement Accreditation</p>
                        <p>✦ Partner Advisor</p>
                        <p>✦ Joint Marketing + GTM</p>
                        <p>✦ Scale-up Revenue Share</p>
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <img
                          loading="lazy"
                          style={{ width: "100%" }}
                          src={require("../../Components/Assets/AboutPiLog/Co-Sell Partner.png")}
                          alt="Spares Data Acquisition-7"
                          width={"100%"}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Tab>
            </Tabs>
          </Row>
        </Container>
      </section>

      <section className="leader-board">
        {/* Other Partner Program design is in text file */}
        <Container>
          <div>
            <h1 class="leader-category">EXECUTIVE TEAM</h1>
            <h6>Meet the executives leading PiLog Group</h6>
          </div>
          <Row>
            <Col lg={3}>
              <div class="leader-card">
                <div class="leader-card-image">
                  <img
                    loading="lazy"
                    className=""
                    src={require("../../Components/Assets/AboutPiLog/Dr.-Salomon-De-Jager_Pic.png")}
                    alt="Dr. Salomon De Jager"
                    width={"50%"}
                  />
                </div>
                <div className="leader-card-body">
                  <div class="leader-category"> Dr. Salomon De Jager </div>
                  <div class="leader-heading"> Chairman </div>
                  <div class="leader-Group"> PiLog Group </div>
                </div>
                <hr />
                <div className="leader-social-media">
                  <div className="d-flex justify-content-around align-items-center">
                    <Link to="">
                      <h6>Learn More ⮕</h6>
                    </Link>
                    <img
                      loading="lazy"
                      className=" bg-dark p-1 border rounded-2"
                      style={{ width: "10%", marginLeft: "4.5rem" }}
                      src={require("../../Components/Assets/Footer/SOCIAL-MEDIA_ICONS-06.png")}
                      alt="Linked In Icon"
                      width={"10%"}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <div class="leader-card">
                <div class="leader-card-image">
                  <img
                    loading="lazy"
                    className=""
                    src={require("../../Components/Assets/AboutPiLog/Dr.-Imad-Syed_Pic.png")}
                    alt="Dr. Imad Syed"
                    width={"50%"}
                  />
                </div>
                <div className="leader-card-body">
                  <div class="leader-category"> Dr. Imad Syed </div>
                  <div class="leader-heading">Co - CEO and CIO </div>
                  <div class="leader-Group">PiLog Group </div>
                </div>
                <hr />
                <div className="leader-social-media">
                  <div className="d-flex justify-content-around align-items-center">
                    <Link to="">
                      <h6>Learn More ⮕</h6>
                    </Link>
                    <img
                      loading="lazy"
                      className=" bg-dark p-1 border rounded-2"
                      style={{ width: "10%", marginLeft: "4.5rem" }}
                      src={require("../../Components/Assets/Footer/SOCIAL-MEDIA_ICONS-06.png")}
                      alt=""
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </Col>

            <Col lg={3}>
              <div class="leader-card">
                <div class="leader-card-image">
                  <img
                    loading="lazy"
                    className=""
                    src={require("../../Components/Assets/AboutPiLog/Gideon-Huisamen_Pic.png")}
                    alt="Gideon Huisamen"
                    width={"50%"}
                  />
                </div>
                <div className="leader-card-body">
                  <div class="leader-category">Gideon Huisamen </div>
                  <div class="leader-heading">Co - Chief Executive Officer</div>
                  <div class="leader-Group">PiLog Group</div>
                </div>
                <hr />
                <div className="leader-social-media">
                  <div className="d-flex justify-content-around align-items-center">
                    <Link to="">
                      <h6>Learn More ⮕</h6>
                    </Link>
                    <img
                      loading="lazy"
                      className=" bg-dark p-1 border rounded-2"
                      style={{ width: "10%", marginLeft: "4.5rem" }}
                      src={require("../../Components/Assets/Footer/SOCIAL-MEDIA_ICONS-06.png")}
                      alt=""
                      width={"10%"}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <div class="leader-card">
                <div class="leader-card-image">
                  <img
                    loading="lazy"
                    className=""
                    src={require("../../Components/Assets/AboutPiLog/Pieter-Strydom_Pic.png")}
                    alt="Pieter Strydom"
                    width={"50%"}
                  />
                </div>
                <div className="leader-card-body">
                  <div class="leader-category"> Pieter Strydom </div>
                  <div class="leader-heading">Co - Chief Executive Officer</div>
                  <div class="leader-Group">PiLog Group</div>
                </div>
                <hr />
                <div className="leader-social-media">
                  <div className="d-flex justify-content-around align-items-center">
                    <Link to="">
                      <h6>Learn More ⮕</h6>
                    </Link>
                    <img
                      loading="lazy"
                      className=" bg-dark p-1 border rounded-2"
                      style={{ width: "10%", marginLeft: "4.5rem" }}
                      src={require("../../Components/Assets/Footer/SOCIAL-MEDIA_ICONS-06.png")}
                      alt=""
                      width={"10%"}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <div class="leader-card">
                <div class="leader-card-image">
                  <img
                    loading="lazy"
                    className=""
                    src={require("../../Components/Assets/AboutPiLog/Wynand-Nortje_Pic.png")}
                    alt=""
                  />
                </div>
                <div className="leader-card-body">
                  <div class="leader-category"> Wynand Nortje</div>
                  <div class="leader-heading">Chief Technology Officer</div>
                  <div class="leader-Group">PiLog Group</div>
                </div>
                <hr />
                <div className="leader-social-media">
                  <div className="d-flex justify-content-around align-items-center">
                    <Link to="">
                      <h6>Learn More ⮕</h6>
                    </Link>
                    <img
                      loading="lazy"
                      className=" bg-dark p-1 border rounded-2"
                      style={{ width: "10%", marginLeft: "4.5rem" }}
                      src={require("../../Components/Assets/Footer/SOCIAL-MEDIA_ICONS-06.png")}
                      alt=""
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <div class="leader-card">
                <div class="leader-card-image">
                  <img
                    loading="lazy"
                    className=""
                    src={require("../../Components/Assets/AboutPiLog/Tracy-Bennett_Pic.png")}
                    alt=""
                  />
                </div>
                <div class="leader-category"> Tracy Bennett </div>
                <div class="leader-heading">Chief Technology Officer</div>
                <div class="leader-Group">PiLog Group</div>

                <hr />
                <div className="leader-social-media">
                  <div className="d-flex justify-content-around align-items-center">
                    <Link to="">
                      <h6>Learn More ⮕</h6>
                    </Link>
                    <img
                      loading="lazy"
                      className=" bg-dark p-1 border rounded-2"
                      style={{ width: "10%", marginLeft: "4.5rem" }}
                      src={require("../../Components/Assets/Footer/SOCIAL-MEDIA_ICONS-06.png")}
                      alt=""
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <div class="leader-card">
                <div class="leader-card-image">
                  <img
                    loading="lazy"
                    className=""
                    src={require("../../Components/Assets/AboutPiLog/Reinhard-Schiel_Pic.png")}
                    alt=""
                  />
                </div>
                <div class="leader-category">Reinhard Schiel</div>
                <div class="leader-heading">Chief Operating Officer</div>
                <div class="leader-Group">Europe and CIS - Zone 2</div>

                <hr />
                <div className="leader-social-media">
                  <div className="d-flex justify-content-around align-items-center">
                    <Link to="">
                      <h6>Learn More ⮕</h6>
                    </Link>
                    <img
                      loading="lazy"
                      className=" bg-dark p-1 border rounded-2"
                      style={{ width: "10%", marginLeft: "4.5rem" }}
                      src={require("../../Components/Assets/Footer/SOCIAL-MEDIA_ICONS-06.png")}
                      alt=""
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <div class="leader-card">
                <div class="leader-card-image">
                  <img
                    loading="lazy"
                    className=""
                    src={require("../../Components/Assets/AboutPiLog/Johan-Zwarts_Pic.png")}
                    alt=""
                  />
                </div>
                <div class="leader-category">Johan Zwarts </div>
                <div class="leader-heading">Chief Operating Officer</div>
                <div class="leader-Group">Africa - Zone2</div>

                <hr />
                <div className="leader-social-media">
                  <div className="d-flex justify-content-around align-items-center">
                    <Link to="">
                      <h6>Learn More ⮕</h6>
                    </Link>
                    <img
                      loading="lazy"
                      className=" bg-dark p-1 border rounded-2"
                      style={{ width: "10%", marginLeft: "4.5rem" }}
                      src={require("../../Components/Assets/Footer/SOCIAL-MEDIA_ICONS-06.png")}
                      alt=""
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-5 zonal-offices-section">
        <Container>
          <div className="mb-5">
            <h2 className="text-center section-title">Zonal Offices</h2>
            <div className="title-underline"></div>
          </div>
          <Row className="mb-5">
            <Col lg={12}>
              <img
                loading="lazy"
                src={require("../../Components/Assets/AboutPiLog/MAP-03.png")}
                className="w-100"
                alt="zonal_map"
              />
            </Col>
          </Row>
          <Row>
            {offices.map((office, index) => (
              <Col lg={3} md={6} sm={12} key={index} className="mb-4">
                <div className="zonal-office">
                  <h4 className="region-title">{office.region}</h4>
                  <p className="office-address">{office.address}</p>
                  <div className="zonal-contact-info">
                    <p className="email-info">
                      <span className="contact-label">Email:</span>
                      <a
                        href={`mailto:${office.email}`}
                        className="contact-link"
                      >
                        {office.email}
                      </a>
                    </p>
                    <p className="phone-info">
                      <span className="contact-label">
                        <b>Tel:</b>
                      </span>
                      <a href={`tel:${office.phone}`} className="contact-link">
                        {office.phone}
                      </a>
                    </p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
};
